const shadows = {
  none: 'none',
  small: '0px 2px 10px 0px rgb(76 78 100 / 22%)',
  medium: '0px 2px 15px 2px rgba(34, 60, 80, 0.2)',
  large: '0px 2px 20px 10px rgba(34, 60, 80, 0.2)',
}

export default shadows
